import SearchIcon from '@mui/icons-material/Search';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import WalletIconWithBadge from '../../wallet/WalletIconWithBadge';
import { Edit } from '@mui/icons-material';
import PropTypes from 'prop-types';
import SavedBankAcountActions from '../../savedBankAcounts/SavedBankAcountActions';

const SavedAccounts = ({ onClick }) => {
    const savedAccounts = useSelector(state => state.juno.savedAccounts);
    const [searchText, setSearchText] = useState('');
    const balancesFiatData = useSelector(state => state.juno.balancesCurrencies);

    const filteredAccounts = savedAccounts.filter(account =>
        account?.accountNickName?.toLowerCase()?.includes(searchText.toLowerCase()),
    );

    const [editAccount, setEditAccount] = useState(null);

    return (
        <>
            <div className="rounded-lg w-full p-2 border-none bg-card-bg flex items-center gap-2">
                <input
                    type="text"
                    className="bg-card-bg placeholder:uppercase w-full !text-primary outline-none"
                    placeholder={'search accounts'}
                    value={searchText}
                    onChange={e => setSearchText(e.target.value)}
                />
                <SearchIcon className="!text-primary" />
            </div>
            <div className="relative mt-2 custom-scrollbar max-h-[500px]">
                {filteredAccounts?.length ? (
                    filteredAccounts
                        .filter(account =>
                            account?.accountNickName
                                ?.toLowerCase()
                                ?.includes(searchText.toLowerCase()),
                        )
                        .map(account => (
                            <div
                                key={account._id}
                                className="flex items-center gap-3 justify-between rounded-lg my-2 p-3 !border border-[#D1D1D6] dark:!border-[#51525C] cursor-pointer"
                                aria-label={`Select account ${account?.accountNickName || ''}`}>
                                <div className="flex gap-3 w-full" onClick={() => onClick(account)}>
                                    <WalletIconWithBadge
                                        currencyIcon={
                                            balancesFiatData?.find(
                                                balance =>
                                                    account.currency == balance.currencyShortName,
                                            )?.currencyIcon
                                        }
                                        height={10}
                                        width={10}
                                        iconDimension={23}
                                        imageDimension={4}
                                        imageStyleClass={'border-1 !border-[#26272B] rounded-lg'}
                                    />
                                    <div className="self-stretch flex flex-col justify-center items-start gap-1">
                                        <div
                                            data-e2e={account?.accountNickName || ''}
                                            className="justify-center !text-primary text-sm font-medium uppercase leading-tight">
                                            {account?.accountNickName || ''}
                                        </div>
                                        <div
                                            data-e2e={account?.sortCode || ''}
                                            className="justify-center text-[#51525C] dark:text-[#D1D1D6] text-xs font-medium uppercase leading-none">
                                            {account?.sortCode || ''}
                                        </div>
                                    </div>
                                </div>
                                <Edit
                                    className="float-right !text-primary z-5"
                                    onClick={() => {
                                        setEditAccount(account);
                                    }}
                                />
                            </div>
                        ))
                ) : (
                    <div className="text-center py-8 text-[#51525C] dark:text-[#D1D1D6]">
                        No accounts match your search
                    </div>
                )}
            </div>
            {editAccount ? (
                <SavedBankAcountActions
                    modalsOnly={true}
                    buttonText={'save'}
                    isAccount={true}
                    isEdit={true}
                    open={true}
                    formData={editAccount}
                    onClose={() => setEditAccount(null)}
                    onBack={() => setEditAccount(null)}
                    onDeleteAccount={() => {
                        setEditAccount(null);
                    }}
                    title={'Edit account'}
                />
            ) : null}
        </>
    );
};

SavedAccounts.propTypes = {
    /**
     * Callback function triggered when an account is selected
     * @param {Object} account - The selected account object
     */
    onClick: PropTypes.func.isRequired,

    /**
     * Optional callback function triggered when the edit button is clicked
     * @param {Object} account - The account to be edited
     */
    onEdit: PropTypes.func,
};

export default SavedAccounts;
